import { defineStyle, defineStyleConfig } from '@chakra-ui/react';
const baseStyle = defineStyle(() => ({
  borderRadius: 'full'
}));
const primary = defineStyle({
  color: 'GREYSCALE.MOON',
  backgroundColor: 'CARNABY.regular',
  _hover: {
    backgroundColor: 'CARNABY.dark'
  },
  _disabled: {
    color: 'GREYSCALE.NEBULA',
    opacity: 'initial',
    backgroundColor: 'GREYSCALE.CONSTELLATION',
    _hover: {
      backgroundColor: 'GREYSCALE.CONSTELLATION !important'
    }
  }
});
const secondary = defineStyle({
  color: 'CARNABY.regular',
  backgroundColor: 'CARNABY.extraLight',
  borderColor: 'CARNABY.regular',
  border: '1px',
  _hover: {
    backgroundColor: 'CARNABY.light'
  }
});
const buttonTheme = defineStyleConfig({
  baseStyle,
  sizes: {
    xl: {
      fontSize: 'lg',
      px: '6',
      h: '14'
    }
  },
  variants: {
    primary,
    secondary
  }
});
export default buttonTheme;